import register from '@kpsys/angularjs-register';
import {KpPaymentFormPresenter} from './kp-payment-form.presenter';
import PaymentDataService from './payment.data-service';
import {AmountTypeDataService} from './amount-type.data-service';
import {PaymentFormModalComponent} from './payment-form-modal/payment-form-modal.component';
import {PaymentGatewayRedirectResponseModalComponent} from './payment-gateway-redirect-response-modal/payment-gateway-redirect-response-modal.component';

export default register('portaro.features.payment')
    .service(AmountTypeDataService.serviceName, AmountTypeDataService)
    .service(KpPaymentFormPresenter.presenterName, KpPaymentFormPresenter)
    .service(PaymentDataService.serviceName, PaymentDataService)
    .component(PaymentFormModalComponent.componentName, PaymentFormModalComponent)
    .component(PaymentGatewayRedirectResponseModalComponent.componentName, PaymentGatewayRedirectResponseModalComponent)
    .name();